import { useTranslation } from 'react-i18next'

import { useUserData } from '../../../../hooks'
import { isStaffUser } from '../../../../utils/user'
import { AttachActionSelect } from '../../../AttachActionSelect'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { FormActionsAttachContainer, FormUploadAction } from '../../../Form'
import {
  QA_NAME_CHATROOM_MESSAGE_EDIT_CANCEL,
  QA_NAME_CHATROOM_MESSAGE_EDIT_SAVE,
} from '../../Chatroom.constants'

import * as styles from './ChatroomMessageEditFormActions.module.css'

function ChatroomMessageEditFormActions({
  attachActionOptions,
  attachOver,
  isDragging,
  isSaveDisabled,
  isSubmitting,
  outboundUuid,
  onAttachAction,
  onCancel,
  onClickSubmit,
  onDragAttachLeave,
  onDragAttachOver,
  onDropFile,
  onFinishUpload,
  onStartUpload,
  onUploadErrors,
}) {
  const { t } = useTranslation()

  const currentUser = useUserData()

  const canAttachFromStorage = isStaffUser(currentUser)

  return (
    <FormActionsAttachContainer
      {...(!isSubmitting
        ? {
            isDragging,
            isOver: attachOver,
            onDragLeave: onDragAttachLeave,
            onDragOver: onDragAttachOver,
          }
        : null)}
      className={styles.chatroomMessageEditFormActions}
      uploadProps={{
        disabled: isSubmitting,
        outboundUuid,
        onDrop: onDropFile,
        onFinishUpload,
        onStartUpload,
        onUploadErrors,
      }}
    >
      <Button.Contained
        className={styles.button}
        disabled={isSaveDisabled}
        height={BUTTON_HEIGHT_32}
        isLoading={isSubmitting}
        qaName={QA_NAME_CHATROOM_MESSAGE_EDIT_SAVE}
        text={t('Modal.SaveBtnKey')}
        onClick={onClickSubmit}
      />
      <Button.Outlined
        className={styles.button}
        disabled={isSubmitting}
        height={BUTTON_HEIGHT_32}
        qaName={QA_NAME_CHATROOM_MESSAGE_EDIT_CANCEL}
        text={t('Modal.CancelBtnKey')}
        onClick={onCancel}
      />
      {canAttachFromStorage ? (
        <AttachActionSelect
          disabled={isSubmitting}
          options={attachActionOptions}
          outboundUuid={outboundUuid}
          placeholder='Chatroom.InputAttachButtonKey'
          onClick={onAttachAction}
          onFinishUpload={onFinishUpload}
          onStartUpload={onStartUpload}
          onUploadErrors={onUploadErrors}
        />
      ) : (
        <FormUploadAction
          disabled={isSubmitting}
          options={{ noDrag: true }}
          outboundUuid={outboundUuid}
          title='Chatroom.InputAttachButtonKey'
          onFinishUpload={onFinishUpload}
          onStartUpload={onStartUpload}
          onUploadErrors={onUploadErrors}
        />
      )}
    </FormActionsAttachContainer>
  )
}

export default ChatroomMessageEditFormActions
